import asianPaintsLogo from "./assets/images/asian-logo.webp";
import birlaLogo from "./assets/images/birla-logo.webp";
import asianPaintsppgLogo from "./assets/images/asian-ppg-logo.webp";
import parrywarelogo from "./assets/images/parryware.webp";
import ceralogo from "./assets/images/cera-logo.webp";
import ganitlogo from "./assets/images/Ganit-logo.webp";
import rrkabellogo from "./assets/images/rrkabel-logo.webp";
import abrologo from "./assets/images/abro-logo.webp";
import marvelmatlogo from "./assets/images/marvelmat-logo.webp";
import decorativepaint from "./assets/images/decorative-paints.webp";
import protectivecoating from "./assets/images/protective-coating.webp";
import hardwaresanitary from "./assets/images/hardware-sanitary.webp";
import pipefittings from "./assets/images/pipe-fittings.webp";
import abroproduct from "./assets/images/abro-product.webp";
import ganitlighting from "./assets/images/ganit-lighting.webp";
import electricals from "./assets/images/electricals.webp";
import matmarvelsanders from "./assets/images/mat-marvel-sanders.webp";
import matsprayguns from "./assets/images/mat-sprayguns.webp";
import matairtools from "./assets/images/mat-airtools.webp";
import matabrasives from "./assets/images/mat-abrasives.webp";
import safety from "./assets/images/safety.webp";
import safetyoverall from "./assets/images/safety-overall.jpeg";
import infrastructure from "./assets/images/infrastructure.webp";
import maintenance from "./assets/images/maintenance.webp";
import agriculture from "./assets/images/agriculture.webp";
import transformer from "./assets/images/transformer.webp";
import engine from "./assets/images/engine.webp";
import pump from "./assets/images/pump.webp";
import adhesivesealant from "./assets/images/adhesive-sealant.webp";
import lubricant from "./assets/images/lubricant.webp";
import cleanerrepair from "./assets/images/cleaner-repair.webp";
import residentiallight from "./assets/images/residential-light.webp";
import commerciallight from "./assets/images/commercial-light.webp";
import electricalsproducts from "./assets/images/electricals-products.webp";
import domesticpipe from "./assets/images/domestic-pipe.webp";
import industrialpipe from "./assets/images/industrial-pipe.webp";
import wallhungwc from "./assets/images/wallhungwc.webp";
import basin from "./assets/images/basin.webp";
import shower from "./assets/images/shower.webp";
import valve from "./assets/images/valve.webp";
import flushtank from "./assets/images/flush-tank.webp";
import bathroomacc from "./assets/images/bathroom-acc.webp";
import asianpaintinterior from "./assets/images/asianpaint-interior.webp";
import asianpaintexterior from "./assets/images/asianpaint-exterior.webp";
import woodpaint from "./assets/images/woodpaint.avif";
import wallputty from "./assets/images/wall-putty.webp";
import waterproof from "./assets/images/water-proof.avif";
import designtexture from "./assets/images/design-texture.webp";
import matmarvellogo from "./assets/images/mat-marvel-logo.webp";
import abrasive from "./assets/images/abrasive.webp";
import lapping from "./assets/images/lapping.webp";
import sanders from "./assets/images/sanders.webp";
import grinders from "./assets/images/grinders.webp";
import backuppad from "./assets/images/backuppad.webp";
import spraygun from "./assets/images/spraygun.webp";
import aircaulking from "./assets/images/aircaulking.webp";
import masking from "./assets/images/masking.webp";
import wipes from "./assets/images/wipes.webp";
import compounds from "./assets/images/compounds.webp";
import painbooth from "./assets/images/painbooth.webp";
import exhaustsystem from "./assets/images/exhaustsystem.webp";
import airdrill from "./assets/images/airdrill.webp";
import cutofftools from "./assets/images/cutofftools.webp";
import impactwrench from "./assets/images/impactwrench.webp";
import ratchetwrenches from "./assets/images/ratchetwrenches.webp";
import Screwdrivers from "./assets/images/Screwdrivers.webp";
import spotdrill from "./assets/images/spotdrill.webp";
import surfaceblaster from "./assets/images/surfaceblaster.webp";
import safetyproduct from "./assets/images/safetyproduct.webp";
import Sockets from "./assets/images/Sockets.webp";
import Automotive from "./assets/images/Automotive.webp";
import WoodCatalogue from "./assets/images/WoodCatalogue.webp";
import HouseKeeping from "./assets/images/HouseKeeping.webp";
import Aerospace from "./assets/images/Aerospace.webp";
import PaintFinishing from "./assets/images/PaintFinishing.webp";
import oem from "./assets/images/oem.webp";
import tools from "./assets/images/tools.webp";
export const brands = [
  {
    name: 'Asian Paints',
    logo: asianPaintsLogo,
    color: '#ED1C24'
  },
  {
    name: 'Birla Opus',
    logo: birlaLogo,
    color: '#1E3A8A',
    textLogo: true
  },
  {
    name: 'Asian Paints PPG',
    logo: asianPaintsppgLogo,
    color: '#0057B8',
    textLogo: true
  },
  {
    name: 'Parryware',
    logo: parrywarelogo,
    color: '#00A0E3',
    textLogo: true
  },
  {
    name: 'GANIT Lighting',
    logo: ganitlogo,
    color: '#F59E0B',
    textLogo: true
  },
  // {
  //   name: 'ABRO',
  //   logo: abrologo,
  //   color: '#059669',
  //   textLogo: true
  // },
  {
    name: 'MAT MARVEL',
    logo: matmarvellogo,
    color: '#4F46E5',
    textLogo: true
  }
];

export const categories = [
    {
    id: 'surface-coating-decorative',
    name: 'Decorative Paints',
    description: 'Interior & exterior wall paints, wood finishes from Asian Paints & Birla Opus',
    bgColor: 'bg-blue-500',
    image: decorativepaint,
    products: [
        {
      name: 'Interior Wall Paints',
      description: 'Premium to economical interior emulsions including Royale, Tractor, and Birla Opus Interior range offering smooth finish, durability, and low VOC solutions.',
      image:asianpaintinterior
    },
    {
      name: 'Exterior Wall Paints',
      description: 'Weather-resistant exterior coatings like Apex Ultima, Ace Exterior, and Birla Opus Exterior for long-lasting protection against harsh climate.',
      image:asianpaintexterior

    },
    {
      name: 'Wood Coatings & Finishes',
      description: 'Complete wood finishing solutions including PU, Melamine, and WoodTech systems for superior protection and premium finish.',
      image:woodpaint
    },
    {
      name: 'Wall Putty & Primers',
      description: 'Surface preparation products including white cement-based putty and primers for smooth and durable paint application.',
      image:wallputty
    },
    {
      name: 'Waterproofing Solutions',
      description: 'Advanced damp-proof and waterproofing systems to prevent leakage, seepage, and structural damage.',
      image: waterproof
    },
    {
      name: 'Designer & Texture Finishes',
      description: 'Decorative textures and designer finishes for premium aesthetic wall designs and modern interiors.',
      image:designtexture
    },
    {
      name: 'Complete Painting Solutions',
      description: 'End-to-end painting systems including primers, emulsions, topcoats, and finishing materials for residential and commercial projects.',
      image: decorativepaint
    }
      // { name: 'Asian Paints Royale', description: 'Luxury interior emulsion with smooth finish', image: 'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?w=300' },
      // { name: 'Asian Paints Apex Ultima', description: 'Premium exterior weather-proof paint', image: 'https://images.unsplash.com/photo-1525909002-1b05e0c869d8?w=300' },
      // { name: 'Asian Paints Tractor Emulsion', description: 'Economical interior wall paint', image: 'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?w=300' },
      // { name: 'Birla Opus Interior Emulsion', description: 'Low VOC eco-friendly interior paint', image: 'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?w=300' },
      // { name: 'Birla Opus Exterior Shield', description: 'Durable exterior coating', image: 'https://images.unsplash.com/photo-1525909002-1b05e0c869d8?w=300' },
      // { name: 'Asian Paints Woodtech PU', description: 'High performance wood coating system', image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=300' },
      // { name: 'Melamine Wood Finish', description: 'Clear wood protective coating', image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=300' },
      // { name: 'Wall Putty (White Cement Based)', description: 'Smooth surface preparation layer', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=300' },
      // { name: 'Damp Proof Waterproofing', description: 'Water leakage protection system', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
      // { name: 'Designer Texture Finishes', description: 'Decorative wall textures', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300' },

      // { name: 'Asian Paints Ace Exterior', description: 'Economical exterior emulsion', image: 'https://images.unsplash.com/photo-1525909002-1b05e0c869d8?w=300' },
      // { name: 'Asian Paints Premium Emulsion', description: 'Mid-range interior paint', image: 'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?w=300' },
      // { name: 'Birla Opus Putty', description: 'Wall preparation putty', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=300' },
    ]
  },

  {
    id: 'surface-coating-protective',
    name: 'Protective Coatings',
    description: 'Industrial protective coatings from Asian Paints PPG for heavy equipment',
    bgColor: 'bg-indigo-600',
    image: protectivecoating,
    products: [
  {
    name: 'Infrastructure',
    description: 'Advanced coatings including epoxies, polyurethanes, and fire protection solutions for long-lasting infrastructure safety.',
    image: infrastructure
  },
  {
    name: 'Maintenance & Repair',
    description: 'Surface-tolerant epoxy coatings designed for harsh coastal and industrial environments, offering strong corrosion and chemical resistance for long-lasting protection.',
    image: maintenance
  },
  {
    name: 'OEM - Agriculture & Construction Equipment',
    description: 'Durable coatings engineered to withstand harsh conditions, heavy wear, and demanding environments while maintaining performance and color retention.',
    image: agriculture
  },
  {
    name: 'OEM - Transformers & Radiators',
    description: 'High-performance coatings designed for excellent corrosion and temperature resistance, ensuring long-term protection and reliability.',
    image: transformer
  },
  {
    name: 'OEM - Engine & Gensets',
    description: 'Versatile coating solutions offering superior aesthetics, corrosion protection, and heat resistance across a wide range of surfaces.',
    image: engine
  },
  {
    name: 'OEM - Pumps, Motors & Valves',
    description: 'Protective coatings that safeguard critical components against corrosion, weathering, and operational stress for extended service life.',
    image: pump
  }
      // { name: 'SIGMACOVER 280', description: 'Epoxy primer for steel protection', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
      // { name: 'APCODUR Rapid Recoat Primer', description: 'Fast drying epoxy primer', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
      // { name: 'SIGMAFAST 278', description: 'Zinc phosphate primer for C5 environment', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
      // { name: 'SIGMAZINC 109 HS', description: 'Zinc rich primer (80% zinc)', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
      // { name: 'SIGMAZINC 102 HS', description: 'Zinc rich primer (70% zinc)', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
      // { name: 'SIGMACOVER 410 MIO', description: 'Intermediate coating layer', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
      // { name: 'SIGMADUR 550', description: 'PU glossy topcoat', image: 'https://images.unsplash.com/photo-1525909002-1b05e0c869d8?w=300' },
      // { name: 'Asian PU Glossy Finish', description: 'High gloss PU coating', image: 'https://images.unsplash.com/photo-1525909002-1b05e0c869d8?w=300' },
      // { name: 'Asian PU Semi Gloss Finish', description: 'Semi-gloss protective coating', image: 'https://images.unsplash.com/photo-1525909002-1b05e0c869d8?w=300' },
      // { name: 'Asian PU Matt Finish', description: 'Matte finish PU coating', image: 'https://images.unsplash.com/photo-1525909002-1b05e0c869d8?w=300' },
      // { name: 'SIGMATHERM 540', description: 'Heat resistant coating up to 600°C', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=300' },
      // { name: 'SIGMAZINC 158', description: 'Zinc silicate coating', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
      // { name: 'Tank Internal Epoxy Coating', description: '2K epoxy for tanks', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },

      // { name: 'SIGMACOVER 620', description: 'Heavy duty epoxy primer', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
      // { name: 'Asian PU Topcoat System', description: 'Complete PU coating system', image: 'https://images.unsplash.com/photo-1525909002-1b05e0c869d8?w=300' },
      // { name: 'Transformer Tank Coating', description: 'Special coating for transformers', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=300' },
      // { name: 'Container Coating System', description: 'Protective coating for containers', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300' },
    ]
  },
 {
    id: 'sanders-polishers',
    name: 'MAT MARVEL Tools',
    description: 'Complete range of industrial and automotive tools, abrasives, and finishing solutions designed for precision, durability, and high performance.',
    bgColor: 'bg-violet-500',
    image:matmarvelsanders,
    products: [
  {
    name: 'Abrasives',
    description: 'Wide range of abrasive solutions for cutting, grinding, and surface finishing applications.',
    image: abrasive
  },
  {
    name: 'Lapping Film',
    description: 'Precision polishing films for fine surface finishing and material removal.',
    image: lapping
  },
  {
    name: 'Sanders',
    description: 'Efficient sanding tools for smooth surface preparation and finishing.',
    image: sanders
  },
  {
    name: 'Grinders',
    description: 'High-performance grinding tools for metalworking and fabrication.',
    image:grinders
  },
  {
    name: 'Backup Pad',
    description: 'Support pads for sanding and polishing applications.',
    image: backuppad
  },
  {
    name: 'Spray Gun',
    description: 'Professional spray guns for paint and coating applications.',
    image: spraygun
  },
  {
    name: 'Air Caulking Gun',
    description: 'Pneumatic tools for precise sealing and adhesive application.',
    image:aircaulking
  },
  {
    name: 'Masking',
    description: 'Masking products for surface protection during painting and finishing.',
    image: masking
  },
  {
    name: 'Wipes',
    description: 'Cleaning wipes for surface preparation and maintenance tasks.',
    image:wipes
  },
  {
    name: 'Polishing Compounds',
    description: 'Compounds for achieving high-gloss and smooth surface finishes.',
    image: compounds
  },
  {
    name: 'Paint Booth',
    description: 'Controlled environments for professional paint application and finishing.',
    image: painbooth
  },
  {
    name: 'Exhaust System',
    description: 'Ventilation systems for removing fumes and maintaining air quality.',
    image: exhaustsystem
  },
  {
    name: 'Air Drills',
    description: 'Pneumatic drilling tools for precision and heavy-duty use.',
    image: airdrill
  },
  {
    name: 'Cut Off Tools',
    description: 'Tools designed for fast and precise cutting operations.',
    image: cutofftools
  },
  {
    name: 'Impact Wrenches',
    description: 'High torque tools for tightening and loosening fasteners.',
    image: impactwrench
  },
  {
    name: 'Ratchet Wrenches',
    description: 'Compact tools for efficient fastening in tight spaces.',
    image: ratchetwrenches
  },
  {
    name: 'Screwdrivers',
    description: 'Durable hand tools for fastening and assembly tasks.',
    image: Screwdrivers
  },
  {
    name: 'Spot Drills',
    description: 'Precision drills for accurate hole positioning.',
    image: spotdrill
  },
  {
    name: 'Surface Blaster',
    description: 'Equipment for surface cleaning and preparation using blasting techniques.',
    image:surfaceblaster
  },
  {
    name: 'Safety Products',
    description: 'Protective equipment for safe industrial and workshop operations.',
    image: safetyproduct
  },
  {
    name: 'Sockets',
    description: 'Socket tools for fastening and mechanical applications.',
    image: Sockets
  },
  {
    name: 'Automotive',
    description: 'Tools and solutions for automotive maintenance and repair.',
    image: Automotive
  },
  {
    name: 'Wood',
    description: 'Tools and abrasives for woodworking and finishing applications.',
    image: WoodCatalogue
  },
  {
    name: 'House Keeping',
    description: 'Cleaning and maintenance solutions for industrial and commercial spaces.',
    image: HouseKeeping
  },
  {
    name: 'Aerospace',
    description: 'Specialized tools and solutions for aerospace applications.',
    image: Aerospace
  },
  {
    name: 'Paint Finishing',
    description: 'Complete solutions for surface finishing and coating applications.',
    image: PaintFinishing
  },
  {
    name: 'OEM',
    description: 'Customized solutions for original equipment manufacturers.',
    image: oem
  },
  {
    name: 'Tools Catalogue',
    description: 'Comprehensive range of industrial tools and equipment.',
    image: tools
  }
 ]
  },
  {
    id: 'hardware-sanitary',
    name: 'Hardware & Sanitary',
    description: 'Complete bathroom fittings and plumbing hardware from Parryware & CERA',
    bgColor: 'bg-cyan-500',
    image: hardwaresanitary,
    products: [
      { name: 'Parryware Wall Hung WC', description: 'Modern space-saving water closet design.', image: wallhungwc },
      { name: 'Parryware Basin Mixer', description: 'Stylish table top and wall hung basins with premium mixer solutions.', image: basin},
      { name: 'Showers & Faucets', description: 'Overhead rain showers and health faucets for enhanced bathroom comfort.', image: shower },
      { name: 'Valves & Plumbing Accessories', description: 'Angle valves, waste pipes, and essential plumbing components.', image: valve },
      { name: 'Flush Systems', description: 'Concealed flush tanks for modern and efficient bathrooms.', image: flushtank },
      { name: 'Bathroom Accessories', description: 'Complete range of bathroom fittings and accessory sets.', image: bathroomacc },
      { name: 'Complete Sanitary Solutions', description: 'Explore our complete range of sanitaryware and bathroom solutions. Contact us for more details.',  image: hardwaresanitary},
    ]
  },
 
//   {
//     id: 'abro-products',
//     name: 'Adhesives, Lubricants & Maintenance Supplies',
//     description: 'Adhesives, sealants, and repair solutions for automotive & industrial use',
//     bgColor: 'bg-red-500',
//     image: abroproduct,
//    products: [
//      {
//     name: 'Adhesives, Sealants & Tapes',
//     description: 'Includes gasket makers, threadlockers, super glue, PVC/CPVC cements, sealants, and heavy-duty tapes for bonding, sealing, and repair applications.',
//     image:adhesivesealant
//   },
//   {
//     name: 'Lubricants & Automotive Fluids',
//     description: 'Range of greases, engine oils, additives, radiator coolants, and service fluids designed to enhance performance and protect automotive systems.',
//     image:lubricant
//   },
//   {
//     name: 'Maintenance, Cleaners & Repair Products',
//     description: 'Comprehensive solutions including spray paints, removers, cleaners, body repair products, and specialty maintenance items. Contact us for full product range.',
//     image:cleanerrepair
//   }
// //   { name: 'ABRO Gasket Maker', description: 'RTV silicone sealant' },
// //   { name: 'ABRO Thread Locker', description: 'Prevents bolt loosening' },
// //   { name: 'ABRO Super Glue', description: 'Instant adhesive' },
// //   { name: 'ABRO PVC Cement', description: 'Pipe bonding adhesive' },
// //   { name: 'ABRO Spray Paint', description: 'Multi-purpose aerosol paint' },
// //   { name: 'ABRO Carb Cleaner', description: 'Removes carbon deposits' },
// //   { name: 'ABRO Brake Cleaner', description: 'Fast drying degreaser' },
// //   { name: 'ABRO Body Filler', description: 'Car dent repair compound' },
// //   { name: 'ABRO Duct Tape', description: 'Heavy duty tape' },
// //   { name: 'ABRO Engine Oil Additive', description: 'Performance enhancer' },
// //   { name: 'ABRO Silicone Sealant', description: 'Multi-purpose sealing solution', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
// // { name: 'ABRO Radiator Coolant', description: 'Engine cooling fluid', image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=300' },
// // { name: 'ABRO Fuel Injector Cleaner', description: 'Improves fuel efficiency', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },
// ]
//   },
  {
    id: 'lighting',
    name: 'GANIT Lighting',
    description: 'Residential and commercial LED lighting solutions',
    bgColor: 'bg-amber-500',
    image: ganitlighting,
   products: [
     {
    name: 'Commercial Lighting',
    description: 'Wide range of LED lighting solutions including panel lights, downlights, tube lights, flood lights, street and highway lights, high bay, and architectural lighting for commercial and outdoor applications.',
    image:commerciallight,
    noObjectCover: true
  },
  {
    name: 'Residential & Decorative Lighting',
    description: 'Energy-efficient LED bulbs, ceiling lights, rope lights, and decorative lighting solutions designed for modern homes and ambiance enhancement.',
    image:residentiallight,
    noObjectCover: true
  }
//   { name: 'LED Panel Light', description: 'Commercial ceiling lighting' },
//   { name: 'LED Downlight', description: 'Recessed spotlight' },
//   { name: 'LED Tube Light', description: 'Energy efficient tube' },
//   { name: 'LED Bulb', description: 'Residential lighting solution' },
//   { name: 'LED Rope Light', description: 'Decorative lighting' },
//   { name: 'Tiranga Rope Light', description: 'Tri-color decorative light' },
//   { name: 'Flood Light', description: 'Outdoor high power light' },
//   { name: 'Street Light', description: 'Road illumination system' },
//   { name: 'Highway Light', description: 'Heavy-duty street lighting' },
//   { name: 'Profile LED Light', description: 'Modern architectural lighting' },
//   { name: 'Commercial High Bay Light', description: 'Warehouse lighting solution', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=300' },
// { name: 'Residential Ceiling LED', description: 'Home ceiling lighting', image: 'https://images.unsplash.com/photo-1565814329452-e1efa11c5b89?w=300' },
]
  },
  {
    id: 'electricals',
    name: 'Electricals',
    description: 'Wires, cables, switches and electrical components',
    bgColor: 'bg-orange-500',
    image: electricals,
   products: [
    {
  name: 'Electricals & Wiring Solutions',
  description: 'Comprehensive range of wires, cables, switches, circuit protection devices, fans, and cable management accessories for safe and efficient residential and commercial electrical installations. Contact us for full product details.',
  image:electricalsproducts
},
// {
//   name: 'Electricals & Wiring Solutions',
//   description: 'Wide range of wires, cables, switches, protection devices, fans, and electrical accessories for residential and commercial use.',
//   image:electricalsproducts
// }
//   { name: 'RR FRLS Wire', description: 'Flame retardant wire' },
//   { name: 'RR HRFR Cable', description: 'Heat resistant cable' },
//   { name: 'RR LSOH Cable', description: 'Low smoke zero halogen cable' },
//   { name: 'Modular Switches', description: 'Modern switch system' },
//   { name: 'Socket & Switch Plates', description: 'Wall electrical fittings' },
//   { name: 'MCB', description: 'Circuit protection device' },
//   { name: 'Distribution Board', description: 'Power distribution panel' },
//   { name: 'Exhaust Fan', description: 'Ventilation system' },
//   { name: 'Ceiling Fan', description: 'Residential fan solution' },
//   { name: 'Cable Tray & Accessories', description: 'Cable management system' },
//   { name: 'Extension Board', description: 'Multi-plug extension unit', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
// { name: 'Cable Joint Kit', description: 'Cable connection kit', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300' },
]
  },
  // MatMarvel Products
 
//   {
//     id: 'spray-guns',
//     name: 'MAT MARVEL Spray Guns',
//     description: 'Professional spray guns for automotive and industrial painting',
//     bgColor: 'bg-purple-500',
//     image: matsprayguns,
//     products: [
//     { name: 'MATMT-WA200P Large Spray Gun', description: 'Pressure feed large type gun for industrial use', image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=300' },
//     { name: 'MATMT-W77G HVLP Spray Gun', description: 'High volume low pressure for smooth finish', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },
//     { name: 'MATMT-4000G Professional HVLP', description: 'High efficiency professional spray gun', image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=300' },
//     { name: 'MATMT-602G Mini Spray Gun', description: 'Compact gun for touch-up jobs', image: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=300' },
//     { name: 'MATMT-W77P Pressure Spray Gun', description: 'Pressure feed coating applications', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },

//     // 🔥 Added from catalogue-style expansion
//     { name: 'HVLP Gravity Feed Spray Gun', description: 'Gravity based HVLP precision painting', image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=300' },
//     { name: 'Mini Detail Spray Gun', description: 'Fine detailing and touch-up work', image: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=300' },
//     { name: 'Airless Spray Gun', description: 'High pressure industrial coating gun', image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=300' },
//     { name: 'Electrostatic Spray Gun', description: 'Advanced coating with minimal wastage', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },

//     // Accessories (important — missing earlier)
//     { name: 'Spray Gun Cleaning Kit', description: 'Full cleaning and maintenance kit', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
//     { name: 'Spray Gun Nozzle Set', description: 'Different nozzle sizes for varied coating', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },
//     { name: 'Air Regulator with Gauge', description: 'Pressure control for spray guns', image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=300' },
//     { name: 'Paint Pressure Pot', description: 'Bulk paint feeding system', image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=300' },
// { name: 'Spray Gun Stand', description: 'Gun holding stand', image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=300' },
//   ]
//   },
//   {
//     id: 'air-tools',
//     name: 'MAT MARVEL Air Tools',
//     description: 'Pneumatic tools for automotive assembly and repair',
//     bgColor: 'bg-teal-500',
//     image: matairtools,
//      products: [
//     { name: 'MATSM-43-4012P Impact Wrench', description: '1/2" mini pneumatic impact wrench', image: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=300' },
//     { name: 'MATGP-1921B Ratchet Wrench', description: '3/8" pneumatic ratchet tool', image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=300' },
//     { name: 'MATOP-510H Air Drill', description: 'Rear exhaust pneumatic drill', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },
//     { name: 'MATGP-2221 Angle Grinder', description: '4" high-speed pneumatic grinder', image: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=300' },
//     { name: 'MATSM-52-3271 Die Grinder', description: 'Precision grinding tool', image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=300' },
//     { name: 'MATSM-AS Auto Screwdriver', description: 'Auto shut-off screwdriver', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },

//     // 🔥 Added realistic catalogue items
//     { name: 'Pneumatic Orbital Sander', description: 'High-speed sanding tool', image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=300' },
//     { name: 'Air Blow Gun', description: 'Cleaning and dust removal tool', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
//     { name: 'Air Hammer', description: 'Heavy duty cutting & chipping tool', image: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=300' },
//     { name: 'Pneumatic Riveter', description: 'Fast rivet installation tool', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },
//     { name: 'Air Polisher', description: 'Surface polishing and finishing tool', image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=300' },
//     { name: 'Air Compressor', description: 'Compressed air supply system', image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=300' },
//   ]
// },
//   {
//     id: 'abrasives-consumables',
//     name: 'MAT CAAPTAIN Abrasives',
//     description: 'Premium discs, sheets, compounds and finishing materials',
//     bgColor: 'bg-rose-500',
//     image: matabrasives,
//     products: [
//     { name: 'Gold Velcro Disc 5"', description: 'High performance sanding disc P80–P2500', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },
//     { name: 'Film Velcro Disc', description: 'Fine finishing film-backed disc', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
//     { name: 'Sanding Sheets 230x280', description: 'Waterproof abrasive sheets', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300' },

//     // Compounds
//     { name: 'MFG 108 Cutting Compound', description: 'Heavy cut compound for deep scratches', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300' },
//     { name: 'MFG 3000 Finishing Compound', description: 'Fine polish for gloss finish', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },

//     // Added missing important range
//     { name: 'Polishing Pad Foam', description: 'Foam pad for polishing machines', image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=300' },
//     { name: 'Wool Polishing Pad', description: 'High cut polishing pad', image: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=300' },
//     { name: 'Abrasive Belt', description: 'Continuous sanding belt for machines', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },
//     { name: 'Scotch Brite Pads', description: 'Surface preparation pads', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
//     { name: 'Premium Wax W6', description: 'Long-lasting protective wax', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
//     { name: 'Microfiber Cloth', description: 'Final polishing cloth', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300' },
//   ]
//   },
  {
    id: 'safety-maintenance',
    name: 'Safety & Consumables',
    description: 'Safety gear, filters, wipes and paint booth consumables',
    bgColor: 'bg-emerald-500',
    image: safety,
    products: [
       {
      name: 'Safety & Consumable Solutions',
      description: 'Complete range of safety equipment, masking materials, wipes, filters, and paint booth consumables for industrial and automotive applications. Contact us for full product details.',
      image: safetyoverall
    }
    // { name: 'Safety Coverall', description: 'Anti-static protective wear', image: safetyoverall},
    // { name: 'Disposable Coverall Suit', description: 'Microporous protection suit', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
    // { name: 'Respirator Mask', description: 'Protection from paint fumes', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
    // { name: 'Safety Gloves Nitrile', description: 'Chemical resistant gloves', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300' },
    // { name: 'Safety Goggles', description: 'Eye protection during spraying', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },

    // { name: 'Tack Cloth Premium', description: 'Dust removal before painting', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300' },
    // { name: 'Masking Tape Roll', description: 'Precision masking tape', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },
    // { name: 'Masking Paper Roll', description: 'Surface protection during paint', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },

    // Filters (important from your category)
    // { name: 'Floor Filter G3', description: 'Paint booth intake filter', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
    // { name: 'Ceiling Filter NF580', description: 'High efficiency ceiling filter', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300' },
    // { name: 'Paint Booth Filter Set', description: 'Complete filtration solution', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
    // { name: 'Ear Protection Plug', description: 'Noise protection gear', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300' },
// { name: 'Safety Shoes', description: 'Industrial safety footwear', image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=300' },
  ]
  },
   {
    id: 'pipes-fittings',
    name: 'Pipes & Fittings',
    description: 'Industrial and domestic piping systems for all applications',
    bgColor: 'bg-slate-500',
    image:pipefittings,
   products: [
      {
    name: 'Domestic Plumbing Systems',
    description: 'Complete range of CPVC, uPVC, and PEX piping systems including Aquarius, CPVC PRO, Pex-a PRO, MultiPex, and lead-free potable water solutions, along with valves and fittings for residential hot and cold water applications.',
    image:domesticpipe
  },
  {
    name: 'Industrial Piping Systems',
    description: 'Advanced industrial piping solutions including CPVC and uPVC systems, Chem Pro range, thermoplastic valves, NRV, and heavy-duty fittings designed for chemical handling, fluid control, and industrial applications.',
    image:industrialpipe
  },
//     {
//   name: 'Pipes & Fittings',
//   description: 'Comprehensive range of CPVC, uPVC, and PEX pipes along with valves, fittings, and accessories for plumbing, industrial, and fluid control applications. Contact us for product details and specifications',
//   image: pipefittings
// }
//   { name: 'CPVC Pipes SDR 11', description: 'Hot & cold water pipes' },
//   { name: 'uPVC Plumbing Pipes', description: 'Drinking water pipes' },
//   { name: 'PEX-AL-PEX Pipes', description: 'Flexible composite piping' },
//   { name: 'Industrial CPVC Pipes', description: 'Chemical resistant pipes' },
//   { name: 'PVC Ball Valve', description: 'Flow control valve' },
//   { name: 'NRV Valve', description: 'Non-return valve' },
//   { name: 'Pipe Elbow & Tee Fittings', description: 'Joint fittings' },
//   { name: 'Union & Coupler Set', description: 'Pipe connection accessories' },
//   { name: 'Industrial Valve Set', description: 'Heavy duty industrial valves', image: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=300' },
// { name: 'Pipe Clamps & Supports', description: 'Pipe mounting accessories', image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300' },
]
  },
];
